"use strict";
var React = require("react");
var LinkedStateMixin = require("react-addons-linked-state-mixin");
var { Input, Row, Col, Checkbox } = require("react-bootstrap");
var ReactDOM = require('react-dom');
var DateTimePicker = require("react-widgets/lib/DateTimePicker");
var momentLocalizer = require("react-widgets/lib/localizers/moment");
var moment = require("moment");
momentLocalizer(moment);
var AuthStore = require("../../stores/AuthenticationStore");
var AuthActions = require("../../actions/AuthenticationActions");
var CompanyStore = require("../../stores/CompanyStore");
var InventoryStore = require("../../stores/InventoryStore");
var InventoryActions = require("../../actions/InventoryActions");
var AddDepartmentModal = require("../Settings/Departments/AddDepartmentModal");
var AddLocationModal = require("../Settings/Locations/AddLocationModal");
var AddTypeModal = require("../Settings/Types/AddTypeModal");
var AddBrandModal = require("../Settings/Brands/AddBrandModal");
var clone = require("clone");
var ReactDOM = require('react-dom');
var _ = require("underscore");
import { Scrollbars } from 'react-custom-scrollbars';

var FilterDropdown = React.createClass({
    mixins: [
      require('react-onclickoutside')
    ],
    getInitialState: function(){
      var userData = AuthStore.getState();
      return {
        userData: userData,
        search_val: '',
        list: this.props.list,
        filteredList: this.props.list,
        list_select_index: -1
      }
    },
    handleClickOutside: function(evt) {
      this.props.collapseAll();
    },
    componentDidMount: function(){
      ReactDOM.findDOMNode(this.refs.filterInput).focus();
    },
    filterList: function(){
      var search_val = ReactDOM.findDOMNode(this.refs.filterInput).value.toLowerCase();
      var list = clone(this.state.list);
      var filteredList = _.filter(list, function(obj){
          var str = obj.name.toLowerCase();
          return str.search(search_val) != -1;
      }.bind(this));
      this.setState({search_val: search_val, filteredList: filteredList, list_select_index: -1 });
    },
    setSelected: function(id, name){
      this.props.setFromDropdown(this.props.section, id, name);
    },
    dropDownList(item, key) {
        var role_name = '';
        if (item.role) {
            role_name = "(" + this.props.roles[item.role].name + ")";
        }

        /* Check if user has the right role to do this action */
        var available = true;
        if(role_name != ""){
            var inthere = $.inArray(item.role, this.state.userData.roles);
            if(inthere == -1){
                available = false;
            }
        }

        return (
          <li key={key} >
            {available ?
              <a tabIndex="-1" href="#" ref={item.id} onClick={this.setSelected.bind(null,item.id, item.name)}>{item.name} <small>{role_name}</small></a> :
              <a tabIndex="-1" href="#" ref={item.id} className="disabled" >{item.name} <small>{role_name}</small></a>
            }
          </li>
        );
    },
    _handleKeyPress: function(e){
        if (e.key === 'ArrowDown') {
            var list = clone(this.state.filteredList);
            var list_select_index = this.state.list_select_index;
            list_select_index++;
            if(list_select_index >= _.size(list) ){
                list_select_index = 0;
            }
            var id = list[list_select_index].id;
            ReactDOM.findDOMNode(this.refs[id]).focus();
            this.setState({list_select_index:list_select_index});
        }
        if (e.key === 'ArrowUp') {
            var list = clone(this.state.filteredList);
            var list_select_index = this.state.list_select_index;
            list_select_index--;
            if(list_select_index < 0 ){
                list_select_index = _.size(list)-1;
            }
            var id = list[list_select_index].id;
            ReactDOM.findDOMNode(this.refs[id]).focus();
            this.setState({list_select_index:list_select_index});
        }
    },
    openModal: function(){
        this.props.openModal(this.props.section,this.state.search_val);
    },
    render: function() {

      return (
        <div className="filter-list-wrapper" onKeyDown={this._handleKeyPress}>
          <div className="filter-popdown-input-wrapper">
            <input type="text" placeholder="Leita…" ref="filterInput" className="filter-popdown-input" onKeyUp={this.filterList} />
            <div className="scrollbar-popout-wrapper">
              <div className="scrollbar-popout">
                <Scrollbars style={{ height: 250 }} className="filter-list">
                  <ul>
                    {(this.state.search_val != '') &&

                    <li className="create"><a tabIndex="-1" href="#" onClick={this.openModal} >Create "{this.state.search_val}"</a></li>
                    }
                    {_.map(this.state.filteredList, this.dropDownList)}
                  </ul>
                </Scrollbars>
                <div className="filter-list-add-wrapper">
                  <button className="btn btn-sm btn-primary" tabIndex="-1" onClick={this.openModal} >+ Bæta við</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
  }

});


var InventoryItemForm = React.createClass({
    mixins: [LinkedStateMixin],
    getInitialState: function() {
      const companyData = CompanyStore.getState();
      const userData = AuthStore.getState();

      const openFields = {
        locationsList: false,
        typesList: false,
        departmentList: false,
        brandList: false,
      }
      const modalWindows = {
        description: false,
        department: false,
        location: false,
        brand: false,
        name: ''
      };

      const formValidation = {
        nameValid: false,
        brandValid: false,
        statusValid: false,
        departmentValid: false,
        locationValid: false,
        typeValid: false,
      };

      // Determine wether the user has a required role to change the equipment
      let hasRole = false;
      if (!this.props.equipment) {
        hasRole = true;
      } else if(userData.roles) {

        for (let i = 0; i < userData.roles.length; i++) {
          if(userData.roles[i] === this.props.equipment) { hasRole = true; }
        }
      }

      var departmentNames = _.indexBy(companyData.departments,'id');
      var homeDepartmentName = departmentNames[userData.home_department].name;
      console.log('homeDepartmentName', homeDepartmentName);

      return {
        "user": userData,
        "user_list": _.indexBy(companyData.users, 'id'),
        "status_list": companyData.statuses,
        "brand_list": companyData.brands,
        "location_list": companyData.locations,
        "type_list": companyData.types,
        "department_list": companyData.departments,
        "role_list": _.indexBy(companyData.roles, "id"),
        "id": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.id)) ?
          ((this.state ? this.state.id : '') || this.props.equipment && this.props.equipment.id || "") : '',
        "status_text": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.status_text)) ?
          ((this.state ? this.state.status_text : '') || this.props.equipment && this.props.equipment.status_text || this.props.cloneData && this.props.cloneData.status_text || "") : '',
        "type_name": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.type_name)) ?
          ((this.state ? this.state.type_name : '') || this.props.equipment && this.props.equipment.type_name || this.props.cloneData && this.props.cloneData.type_name || "") : '',
        "location_name": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.location_nam)) ?
          ((this.state ? this.state.location_name : '') || this.props.equipment && this.props.equipment.location_name || this.props.cloneData && this.props.cloneData.location_name || "") : '',
        "department_name": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.department_name)) ?
          ((this.state ? this.state.department_name : '') || this.props.equipment && this.props.equipment.department_name || this.props.cloneData && this.props.cloneData.department_name || "") : '',
        "name": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.name)) ?
          ((this.state ? this.state.name : '') || this.props.equipment && this.props.equipment.name || this.props.cloneData && this.props.cloneData.name || "") : '',
        "description": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.description)) ?
          ((this.state ? this.state.description : '') || this.props.equipment && this.props.equipment.description || this.props.cloneData && this.props.cloneData.description || "") : '',
        "picture": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.picture)) ?
          ((this.state ? this.state.picture : '') || this.props.equipment && this.props.equipment.picture || null) : null,
        "purchase_date": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.purchase_date)) ?
          ((this.state ? this.state.purchase_date : '') || this.props.equipment && this.props.equipment.purchase_date || this.props.cloneData && this.props.cloneData.purchase_date || moment().format("YYYY-MM-DD")) : moment().format("YYYY-MM-DD"),
        "purchase_price": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.purchase_price)) ?
          ((this.state ? this.state.purchase_price : '') || this.props.equipment && this.props.equipment.purchase_price || this.props.cloneData && this.props.cloneData.purchase_price || 0) : 0,
        "internal_cost": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.internal_cost)) ?
          ((this.state ? this.state.internal_cost : '') || this.props.equipment && this.props.equipment.internal_cost || this.props.cloneData && this.props.cloneData.internal_cost || 0) : 0,
        "serial_number": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.serial_number)) ?
          ((this.state ? this.state.serial_number : '') || this.props.equipment && this.props.equipment.serial_number || "") : '',
        "local_number": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.local_number)) ?
          ((this.state ? this.state.local_number : '') || this.props.equipment && this.props.equipment.local_number || "") : '',
        "mac_address": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.mac_address)) ?
          ((this.state ? this.state.mac_address : '') || this.props.equipment && this.props.equipment.mac_address || "") : '',
        "nfc_tag": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.nfc_tag)) ?
          ((this.state ? this.state.nfc_tag : '') || this.props.equipment && this.props.equipment.nfc_tag || "") : '',
        "barcode": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.barcode)) ?
          ((this.state ? this.state.barcode : '') || this.props.equipment && this.props.equipment.barcode || "") : '',
        "account_key": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.account_key)) ?
          ((this.state ? this.state.account_key : '') || this.props.equipment && this.props.equipment.account_key || "") : '',
        "home_use": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.home_use)) ?
          ((this.state ? this.state.home_use : false) || this.props.equipment && this.props.equipment.home_use || false) : false,
        "creation_date": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.creation_date)) ?
          ((this.state ? this.state.creation_date : '') || this.props.equipment && this.props.equipment.creation_date || "") : '',
        "modification_date": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.modification_date)) ?
          ((this.state ? this.state.modification_date : '') || this.props.equipment && this.props.equipment.modification_date || "") : '',
        "account": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.account)) ?
          ((this.state ? this.state.account : '') || this.props.equipment && this.props.equipment.account || userData.account) : '',
        "type": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.type)) ?
          ((this.state ? this.state.type : '') || this.props.equipment && this.props.equipment.type || this.props.cloneData && this.props.cloneData.type || "") : '',
        "department": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.department)) ?
          ((this.state ? this.state.department : '') || this.props.equipment && this.props.equipment.department || this.props.cloneData && this.props.cloneData.department || "") : '',
        "location": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.location)) ?
          ((this.state ? this.state.location : '') || this.props.equipment && this.props.equipment.location || this.props.cloneData && this.props.cloneData.location || "") : '',
        "status": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.status)) ?
          ((this.state ? this.state.status : '') || this.props.equipment && this.props.equipment.status || this.props.cloneData && this.props.cloneData.status || "8ee7ff88-4c91-43ee-9a56-b1e7e93ebebd") : '8ee7ff88-4c91-43ee-9a56-b1e7e93ebebd',
        "eq_user": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.eq_user)) ?
          ((this.state ? this.state.eq_user : '') || this.props.equipment && this.props.equipment.user || userData.id) : '',
        "created_by_user": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.created_by_user)) ?
          ((this.state ? this.state.created_by_user : '') || this.props.equipment && this.props.equipment.created_by_user || userData.id) : '',
        "modified_by_user": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.modified_by_user)) ?
          ((this.state ? this.state.modified_by_user : '') || this.props.equipment && this.props.equipment.modified_by_user || "") : '',
        "showFields": openFields,
        "modalWindows": modalWindows,
        "advanced_open": false,
        "brand": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.brand)) ?
          ((this.state ? this.state.brand : '') || this.props.equipment && this.props.equipment.brand || this.props.cloneData && this.props.cloneData.brand || '') : '',
        "brand_name": (this.props.equipment || (this.props && this.props.cloneData) || (this.state && this.state.brand_name)) ?
          ((this.state ? this.state.brand_name : '') || this.props.equipment && this.props.equipment.brand_name || this.props.cloneData && this.props.cloneData.brand_name || '') : '',
        quantity: 1,
        hasSubmitted: false,
        formValidation: formValidation,
      }
    },
    componentWillMount() {
      AuthActions.getUserInfo();
    },
    componentDidMount() {
      InventoryStore.listen(this.onAdd);
      CompanyStore.listen(this.onChange);
      AuthStore.listen(this.onChange);
    },
    componentWillUnmount() {
      CompanyStore.unlisten(this.onAdd);
      CompanyStore.unlisten(this.onChange);
      InventoryStore.unlisten(this.onChange);
      AuthStore.unlisten(this.onChange);
    },
    onChange: function() {
        this.setState(this.getInitialState());
    },
    onAdd: function(){
        if(!this.props.equipment){
            this.props.onClose();
        }
    },
    dropDownList(item, key) {
        return (
            <option key={key} value={item.id}>{item.name}</option>
        );
    },
    mapTypeList(type, key) {
        var role_name = "";
        if (type.role) {
            role_name = "("+this.state.role_list[type.role].name+")";
        }
        return (
            <option key={key} value={type.id}>{type.name+" "+role_name}</option>
        );
    },
    onPurchaseDateChange: function(date) {
      if(date) {
        this.setState({purchase_date: moment(date).format("YYYY-MM-DD")});
      }
    },
    collapseAll: function(section){
      var openFields = {
        locationsList: false,
        typesList: false,
        departmentList: false,
        brandList: false,
      }
      if(section){
        openFields[section] =  true;
      }
      this.setState({showFields: openFields});
    },
    collapse: function (section){
        if(this.state.showFields){
            var elem = clone(this.state.showFields);
            elem[section] =  !elem[section];
            this.setState({showFields: elem});
        }
    },
    setFromDropdown(section, value, name){
      var newstate = clone(this.state);
      newstate[section] = value;
      newstate[section + '_name'] = name;
      this.setState(newstate);
      this.collapseAll();
    },
    closeModal: function(modal){
      var modalWindows = {
        description: false,
        descriptionName: '',
        department: false,
        departmentName: '',
        location: false,
        locationName: '',
        brand: false,
        brandName: '',
      }
      this.setState({ modalWindows: modalWindows });
    },
    openModal: function(modal, name){
        var newState = clone(this.state.modalWindows);
        newState[modal] = true;
        if(!name){
            name = '';
        }
        newState.name = name;
        this.setState({ modalWindows: newState });
    },
    mapUserDropdown: function(user){
        return (
          <option key={user.id} value={user.id} >{user.first_name} {user.last_name} ({user.username})</option>
        )
    },
    toggleAdvanced: function() {
        this.setState({ advanced_open: !this.state.advanced_open });
    },
    onSubmit() {
      if (this.state.name === '' || this.state.department === '' || this.state.type === '') {
        this.setState({
          hasSubmitted: true,
          formValidation: {
            nameValid: this.state.name !== '',
            departmentValid: this.state.department !== '',
            typeValid: this.state.type !== '',
          },
        });
      } else {
        var newItem = {
          "id": this.state.id,
          "account": this.state.account,
          "name": this.state.name,
          "description": this.state.description,
          "picture": this.state.picture,
          "purchase_price": this.state.purchase_price,
          "internal_cost": this.state.internal_cost,
          "serial_number": this.state.serial_number,
          "local_number": this.state.local_number,
          "mac_address": this.state.mac_address,
          "nfc_tag": this.state.nfc_tag,
          "account_key": this.state.account_key,
          "home_use": this.state.home_use,
          "type": this.state.type,
          "department": this.state.department,
          "location": this.state.location,
          "status": this.state.status,
          "user": this.state.eq_user,
          "created_by_user": this.state.created_by_user,
          "modified_by_user": this.state.modified_by_user,
          "brand": this.state.brand,
          "barcode": this.state.barcode,
        };

        if (this.state.purchase_date) {
          newItem["purchase_date"] = this.state.purchase_date;
        }

        if (this.props.equipment) {
          InventoryActions.editItem(newItem);
        } else {
          // In add mode
          for (let i = 0; i < (this.state.quantity || 1); i++) {
            InventoryActions.addItem(newItem);
          }
        }
      }
    },
    render: function() {
      var purchaseDate =  this.state.purchase_date && new Date(this.state.purchase_date) || null;
      return (
          <div className="modal-body-inner">
            {(this.state.showFields['departmentList'] || this.state.showFields['locationsList'] || this.state.showFields['typeList']) &&
              <div className="modal-body-dropdown-overlay"></div>
            }
            <Row>
              <Col md={3}>
                <label className="control-label">Vörumerki</label>
                  {(this.state.showFields['brandList']) ?
                    <FilterDropdown
                      list={this.state.brand_list}
                      section="brand"
                      collapseAll={this.collapseAll}
                      setFromDropdown={this.setFromDropdown}
                      openModal={this.openModal}
                    />
                  :
                    <div
                      className="addfield"
                      onClick={this.collapse.bind(null,'brandList')}
                    >
                      <a
                        href="#"
                        className="form-control"
                        onFocus={this.collapseAll.bind(null,'brandList')}
                      >
                        {this.state.brand_name ?
                          <span className="addfield-label">{this.state.brand_name}</span>
                        :
                          "+ Veldu vörumerki"
                        }
                      </a>
                    </div>
                  }
                  <AddBrandModal
                    name={this.state.modalWindows.name}
                    show={this.state.modalWindows.brand}
                    onHide={this.closeModal}
                  />
              </Col>
              <Col md={6}>
                <Input
                  label="Vara *"
                  type="text"
                  className={`input-lg${(this.state.hasSubmitted && !this.state.formValidation.nameValid) ? ' error' : ''}`}
                  placeholder="Sláðu inn vöru t.d. MacBook Pro"
                  valueLink={this.linkState("name")}
                />
              </Col>
              <Col md={3}>
                <Input
                  ref="status"
                  label="Staða"
                  className="input-lg"
                  type="select"
                  valueLink={this.linkState("status")}
                >
                  <option key="select status" value={null}>Veldu stöðu</option>
                  {_.map(this.state.status_list, this.dropDownList)}
                </Input>
              </Col>
            </Row>
            <Row>
              <Col md={this.props.mode === 'add' ? 10 : 12}>
                <Input
                  label="Lýsing"
                  type="text"
                  className="input-lg"
                  placeholder="Sláðu inn lýsingu"
                  valueLink={this.linkState("description")}
                  onFocus={this.collapseAll}
                />
              </Col>
              {this.props.mode === 'add' &&
                <Col md={2}>
                  <Input label="Fjöldi" type="number" className="input-lg" placeholder="Fjöldi" valueLink={this.linkState('quantity')} />
                </Col>
              }
            </Row>
            <Row className="enfrow">
                <Col md={4}>
                  <label className="control-label">Deild *</label>
                  {(this.state.showFields['departmentList']) ?
                    <FilterDropdown
                      list={this.state.department_list}
                      section="department"
                      collapseAll={this.collapseAll}
                      setFromDropdown={this.setFromDropdown}
                      openModal={this.openModal}
                    />
                  :
                    <div
                      className="addfield"
                      onClick={this.collapse.bind(null,'departmentList')}
                    >
                      <a
                        href="#"
                        className={`form-control${(this.state.hasSubmitted && !this.state.formValidation.departmentValid) ? ' error' : ''}`}
                        onFocus={this.collapseAll.bind(null,'departmentList')}
                      >
                        {(this.state.department_name) ? <span className="addfield-label">{this.state.department_name}</span> : "+ Veldu deild" }
                      </a>
                    </div>
                  }
                  <AddDepartmentModal
                    name={this.state.modalWindows.name}
                    show={this.state.modalWindows.department}
                    onHide={this.closeModal}
                  />
                </Col>
                <Col md={4}>
                  <label className="control-label">Staðsetning</label>
                  {(this.state.showFields['locationsList']) ?
                    <FilterDropdown
                      list={this.state.location_list}
                      section="location"
                      collapseAll={this.collapseAll}
                      setFromDropdown={this.setFromDropdown}
                      openModal={this.openModal}
                    />
                  :
                    <div
                      className="addfield"
                      onClick={this.collapse.bind(null,'locationsList')}
                    >
                      <a
                        href="#"
                        className="form-control"
                        onFocus={this.collapseAll.bind(null,'locationsList')}
                      >
                        {(this.state.location_name) ? <span className="addfield-label">{this.state.location_name}</span> : "+ Veldu staðsetningu" }
                      </a>
                    </div>
                  }
                  <AddLocationModal name={this.state.modalWindows.name} show={this.state.modalWindows.location} onHide={this.closeModal}/>
                </Col>
                <Col md={4}>
                    <label className="control-label">Tegund *</label>
                    {(this.state.showFields['typeList']) ?
                      <FilterDropdown list={this.state.type_list} roles={this.state.role_list} section="type" collapseAll={this.collapseAll} setFromDropdown={this.setFromDropdown} openModal={this.openModal} />
                    :
                      <div className="addfield" onClick={this.collapse.bind(null,'typeList')}>
                        <a
                          href="#"
                          className={`form-control${(this.state.hasSubmitted && !this.state.formValidation.typeValid) ? ' error' : ''}`}
                          onFocus={this.collapseAll.bind(null,'typeList')}
                        >
                          {(this.state.type_name) ? <span className="addfield-label">{this.state.type_name}</span> : "+ Veldu tegund" }
                        </a>
                      </div>
                    }
                    <AddTypeModal name={this.state.modalWindows.name} show={this.state.modalWindows.type} onHide={this.closeModal}/>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <Input label="Kaupverð" type="text" valueLink={this.linkState("purchase_price")} onFocus={this.collapseAll}/>
                </Col>
                <Col md={6}>
                    <label>Kaupdagur</label>
                    <DateTimePicker culture={"en-GB"} calendar={true} time={false} format="DD. MMM YYYY" value={purchaseDate} defaultText="Please select a date" onChange={this.onPurchaseDateChange}/>
                </Col>
            </Row>
            <hr />
            <div className="item-form-advanced-wrapper" onClick={this.toggleAdvanced}>
                Ítarupplýsingar <button className="btn btn-default btn-xs"><span className="glyphicon glyphicon-chevron-down"></span></button>
            </div>
            {(this.state.advanced_open) &&
            <div>
                <Row>
                    <Col md={4}>
                        <Input label="Innri kostnaður" type="text" valueLink={this.linkState("internal_cost")}/>
                    </Col>
                    <Col md={4}>
                        <Input label="Bókhaldslykill" type="text" placeholder="Sláðu inn bókhaldslykil" valueLink={this.linkState("account_key")}/>
                    </Col>
                    <Col md={4}>
                        <label>
                          <input type="checkbox" defaultChecked={this.state.home_use} checkedLink={this.linkState("home_use")} /> Heimabúnaður
                        </label>
                        {(this.state.home_use) &&
                        <select className="form-control" valueLink={this.linkState("eq_user")} >
                            {_.map(this.state.user_list, this.mapUserDropdown)}
                        </select>
                        }
                    </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <Input label="Raðnúmer" type="text" placeholder="Sláðu inn raðnúmer" valueLink={this.linkState("serial_number")}/>
                  </Col>
                  <Col md={4}>
                    <Input label="NFC tag" type="text" placeholder="Sláðu inn nfc númer" valueLink={this.linkState("nfc_tag")}/>
                  </Col>
                  <Col md={4}>
                    <Input label="Strikamerki" type="text" placeholder="Sláðu inn strikamerkisnúmer" valueLink={this.linkState("barcode")}/>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <Input label="Auðkennisnúmer" type="text" placeholder="Sláðu inn auðkennisnúmer" valueLink={this.linkState("local_number")}/>
                  </Col>
                </Row>
            </div>
          }
        </div>
      );
    }
});

module.exports = InventoryItemForm;



// WEBPACK FOOTER //
// ./app/scripts/ui/Inventory/InventoryItemForm.js